module.exports = __webpack_public_path__ + "static/media/tambola-background.90fda87e.svg";